<template>
  <div class="bc-black"></div>
</template>

<script>
import { oAuthMixin } from "@/mixins/oAuthMixin";

export default {
  name: "OAuthRedirectPage",
  mixins: [oAuthMixin],
  metaInfo: {
    title: "Redirect",
  },
};
</script>

<style lang="scss">
@import "@/scss/_classes.scss";
</style>
